module.exports = __webpack_public_path__ + "static/scale-model-of-houston-texas-f2a566651a4d0b778ea9130edabbfa1b.png";